import { Logo } from "@paribus/shared-ui";
import { XCircle } from "lucide-react";

import { Loading, Markdown } from "../ui";
import { BAASignSection } from "./BAASignSection";

interface BAAPageViewProps {
  content: string | null;
  isLoading: boolean;
  error: string | null;
  showSignSection?: boolean;
}

export const BAAPageView = ({ content, isLoading, error, showSignSection }: BAAPageViewProps) => {
  if (isLoading) {
    return <Loading />;
  }

  return (
    <div className="min-h-screen bg-primary-subtle px-4 py-12 font-sans sm:px-6 lg:px-8">
      <div className="mx-auto w-full lg:w-[80%]">
        {/* Logo/Branding */}
        <div className="mb-10 flex translate-y-[-10px] flex-col items-center duration-300 animate-in fade-in slide-in-from-top-4">
          <Logo variant="stacked" size="lg" />
        </div>

        {/* Header */}
        <div className="mb-8 text-center duration-500 animate-in fade-in zoom-in-95">
          <h1 className="mb-3 text-4xl font-bold tracking-tight text-foreground">
            Business Associate <span className="text-primary">Agreement</span>
          </h1>
          {showSignSection && (
            <p className="mx-auto max-w-lg text-lg leading-relaxed text-muted-foreground">
              Please review and accept the agreement to continue to your dashboard.
            </p>
          )}
        </div>

        {error && (
          <div className="mb-8 flex items-center rounded-2xl border border-destructive-border bg-destructive-subtle/50 p-4 text-destructive-text backdrop-blur-sm animate-in fade-in slide-in-from-top-2">
            <XCircle className="mr-3 h-5 w-5 flex-shrink-0 text-destructive-text" />
            <span className="text-sm font-medium">{error}</span>
          </div>
        )}

        <div className="mb-10 rounded-2xl border border-white/40 bg-card/80 px-10 py-12 shadow-[0_8px_40px_rgba(0,0,0,0.08)] backdrop-blur-xl duration-500 animate-in fade-in zoom-in-95 sm:px-14 sm:py-14">
          <Markdown content={content || ""} />
        </div>

        {showSignSection && <BAASignSection />}

        {/* Footer Note */}
        <div className="mt-8 text-center duration-300 animate-in fade-in slide-in-from-bottom-2">
          <p className="text-sm font-medium text-muted-foreground">
            Protected by <span className="text-muted-foreground">Paribus AI Security</span>
          </p>
        </div>
      </div>
    </div>
  );
};
